<script>
    import { onMount } from "svelte";

    import PageSection from "../../components/PageSection.svelte";
    import NavigationButtons from "../../components/NavigationButtons.svelte";
    import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
    import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
    import Form from "../../components/Form.svelte";
    import FormRow from "../../components/FormRow.svelte";
    import FormColumn from "../../components/FormColumn.svelte";

    import model from "../../stores/modelStore";
    import { projectSettings } from "../../config";

    export let pageTitle = null;
    export let lastVisitedPage = null;
    export let disabled = false;

    let buttons;

    document.title = pageTitle;

    const handleSubmit = async () => {
        buttons.blockNext();
        buttons.next();
        buttons.unblock();
    };
</script>

<PageSection>
    <Form id="form-landing-page" on:submit={handleSubmit}>
        <FormRow class="justify-content-center">
            <FormColumn ccols="8" cclass="col-sm-12">
                <h1 class="text-center">{projectSettings.classActionName}</h1>
            </FormColumn>
        </FormRow>
        {#if $model.completed}
        
            <FormRow class="justify-content-md-center">
                <FormColumn ccols="8" cclass="col-sm-12">
                    <p>
                        Hello {$model.firstName}
                        {$model.surname},
                    </p>
                    <p>
                        You have previously submitted the Additional Information Form, you are unable to complete this form again. 
                        If you need to amend any of the details provided, please contact Shine Lawyers on 
                        <ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
                        <ClassActionEmailAddress></ClassActionEmailAddress>.
                    </p>
                    <p>
                        Yours sincerely,
                        <br/>
                        Shine Lawyers
                    </p>
                </FormColumn>
            </FormRow>

        {:else}

            <FormRow class="justify-content-md-center">
                <FormColumn ccols="8" cclass="col-sm-12">
                    <h2 class="text-center">ADDITIONAL INFORMATION FORM</h2>

                    <p>
                        Hello {$model.firstName}
                        {$model.surname},
                    </p>
                    <p>
                        This form includes requests to, if available, upload copies
                        of letters from Toyota regarding the DPF issue as well as
                        copies of your service records.
                    </p>
                    <p>
                        To provide additional information for your registration for
                        the Toyota Action please click "Begin form".
                    </p>
                </FormColumn>
            </FormRow>
            <FormRow class="justify-content-md-center register-btn confirmation-hide">
                <FormColumn class="text-center">
                    <NavigationButtons
                        showPrevious={false}
                        bind:buttons
                        nextPageLabel="Begin Form"
                        disableNext={disabled}
                    ></NavigationButtons>
                </FormColumn>
            </FormRow>

            <FormRow class="justify-content-md-center" sstyle="margin-top: 12px;">
                <FormColumn ccols="8" cclass="col-sm-12">
                    <p>
                        If you require support completing this form, please contact
                        Shine Lawyers on <ClassActionPhoneNumber
                        ></ClassActionPhoneNumber>
                        or via email to <ClassActionEmailAddress
                        ></ClassActionEmailAddress>.
                    </p>
                </FormColumn>
            </FormRow>

        {/if}
    </Form>
</PageSection>

<style>
    h1 {
        margin-bottom: 20px;
    }

    h2 {
        font-size: 1.1em;
        margin-bottom: 16px;
    }

    h2 {
        font-weight: 700;
    }
</style>
